/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { CheckUsageDto } from './check-usage.dto';

export const CheckUsageMapper = entity<CheckUsageDto>();
